import React, { useState, ChangeEvent, useEffect } from "react";
import { useTranslation } from "react-i18next";

import formValidationSvc from "../../../services/formValidationSvc";
import { modalViewGAEvent } from "../../../utils/ga";
import { InputBox } from "../../FormElement/InputBox";
import "./styles.scss";

export interface IModalCreateNewLabelProps {
  onClose: () => void;
  onCreateLabel: (labelName: string) => void;
  mode: "create" | "update";
  currentLabelName?: string;
}

export const ModalCreateNewLabel: React.FunctionComponent<
  IModalCreateNewLabelProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityListPage.modalCreateNewLabel.${key}`);

  const [labelName, setLabelName] = useState<string>("");

  const { onClose, onCreateLabel, mode, currentLabelName } = props;

  // on Create
  const onCreate = () => {
    onCreateLabel(labelName);
  };

  // Send GA event on open
  useEffect(() => {
    modalViewGAEvent("create-new-label");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="modal-default modal-create-new-label">
      <div className="modal-mains">
        <button
          className="btn-close"
          onClick={() => {
            onClose();
          }}
        ></button>
        <div className="top-title">
          {t(mode === "create" ? "create_new_label" : "update_label")}
        </div>
        {mode === "update" && (
          <div className="current-label-name">
            <span>{currentLabelName}</span>
          </div>
        )}
        <div className="title-bar">
          <div className="label-title flex">
            {t("title")}
            <span className="little-txt">({t("up_to_16_chars")})</span>
          </div>
          <InputBox
            value={labelName}
            placeholder={t("label_title_here")}
            classNameContainer={"create-label-input"}
            pattern="[\W\w]{0,16}"
            onChange={() => {}}
            onChangeEvent={(event: ChangeEvent<HTMLInputElement>) => {
              setLabelName(
                formValidationSvc.validateInputEnteringPattern(event, labelName)
              );
            }}
          />
        </div>
        <div className="bottom-btns">
          <button
            className="btn btn-border"
            onClick={() => {
              onClose();
            }}
          >
            {t("cancel")}
          </button>
          <button
            className="btn btn-blue"
            onClick={() => {
              onCreate();
            }}
          >
            {t(mode)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalCreateNewLabel;
